import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryLoyaltyProgramPage } from "@/strapiQuery/loyaltyProgram";
import { LoyaltyProgramPageContent } from "@/components/pages/loyaltyProgram/LoyaltyProgram";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");

  const loyaltyProgramPageContentPromise =
    getStrapiEntity<LoyaltyProgramPageContent>(
      "programme-fidelite-pro",
      queryLoyaltyProgramPage
    );

  const [layout, loyaltyProgramPageContent] = await Promise.all([
    layoutPromise,
    loyaltyProgramPageContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      ...loyaltyProgramPageContent,
      intlMessages,
      defaultCanonicalRoute: routes.loyaltyProgram,
    },
    revalidate: 10,
  };
};

export { LoyaltyProgram as default } from "@/components/pages/loyaltyProgram/LoyaltyProgram";
